import React, { FunctionComponent, ReactElement, ReactText } from 'react';
import ReactTags, { TagComponentProps } from 'react-tag-autocomplete';

import {
  CustomFieldKeyValuesEntry,
  CustomFieldPayloadOperations
} from '@components/asset/modal/tabs/edit/EditTabTypes';
import { StandardPill } from '@components/library/pill';

interface MultiValueFreeEntryProps {
  dispatchCustomFieldValue: (
    optionValue: ReactText,
    operation: CustomFieldPayloadOperations,
    customFieldValueId?: string
  ) => void;
  existingCustomFieldMap: CustomFieldKeyValuesEntry;
}

// These are the keycodes for what input triggers
// creation of a new tag
const tagDelimiters = [
  9 /* tab key */,
  13 /* enter key */,
  188 /* comma */
];

export const MultiValueFreeEntry: FunctionComponent<MultiValueFreeEntryProps> = ({
  existingCustomFieldMap,
  dispatchCustomFieldValue
}) => {
  const customFieldValueTags = existingCustomFieldMap?.customFieldValues.map((cfv) => ({
    id: cfv.key,
    name: cfv.value
  }));

  const TagComponent = (props: TagComponentProps): ReactElement => (
    <StandardPill
      onClose={(): void => {
        dispatchCustomFieldValue(props.tag.name, CustomFieldPayloadOperations.Delete, props.tag.id as string);
      }}
      value={props.tag.id}
    >
      {props.tag.name}
    </StandardPill>
  );

  return (
    <div className="custom-field-values-input-container">
      <div className="custom-field-values-input">
        <div className="tags-container">
          <ReactTags
            addOnBlur
            allowBackspace
            allowNew
            autofocus={false}
            delimiters={tagDelimiters}
            handleAddition={(tag): void => dispatchCustomFieldValue(tag.name, CustomFieldPayloadOperations.Create)}
            handleDelete={(i): void => {
              if (i > -1) {
                const deletedTag = customFieldValueTags[i];
                dispatchCustomFieldValue(deletedTag.name, CustomFieldPayloadOperations.Delete, deletedTag.id);
              }
            }}
            minQueryLength={1}
            placeholder={
              (!customFieldValueTags || customFieldValueTags.length === 0)
                ? bfTranslate('Input value(s)')
                : ''
            }
            tagComponent={TagComponent}
            tags={customFieldValueTags}
          />
        </div>
      </div>
    </div>
  );
};
